import React from 'react';

const HeaderDropDownIcon = ({fillColor = '#b7b7b7'}) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={16} height={9} fill="none">
      <path
        stroke={fillColor}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeMiterlimit={10}
        strokeWidth={1.5}
        d="M14.6 1.458 9.167 6.893a1.655 1.655 0 0 1-2.334 0L1.4 1.458"
      />
    </svg>
  );
};

export default HeaderDropDownIcon;
